export const headline = [
  {
    account: 'cindywritescode',
    bio: 'Click on the links below for more information about my coding journey'
  }
];

export const links = [
  {
    id: 1,
    name: 'Instagram',
    url: 'https://www.instagram.com/cindywritescode/',
  },
  {
    id: 2,
    name: 'YouTube',
    url: 'https://www.youtube.com/channel/UCsh7Yv4gvEA8IAlhMK7oOCw',
  },
  {
    id: 3,
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/lihsin-liang/',
  },
  {
    id: 4,
    name: 'GitHub',
    url: 'https://github.com/Cindywritescode',
  },
  {
    id: 5,
    name: 'Portfolio',
    url: 'https://www.notion.so/cindy-liang/Cindy-Liang-363ef0b911f841cc906acfb6f30122b8',
  },
];